module.exports = __webpack_public_path__ + "static/nav-home-bg-0663e42278f4112a44cdfde139143a4c.jpg";